import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "dashboard_trial_banner_collapsed"
const LEARN_MORE_STORAGE_KEY = "dashboard_trial_whats_included_collapsed"

export default class extends Controller {
  static targets = [
    "bannerWrapper",
    "collapseLabel",
    "collapseIcon",
    "learnMoreHeader",
    "learnMoreBody",
    "learnMoreCaret"
  ]

  connect() {
    if (this.hasBannerWrapperTarget) {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored === "true") {
        this.bannerWrapperTarget.classList.add("collapsed")
        this.updateCollapseLabel(true)
        this.updateCollapseIcon(true)
      }
    }
    const learnMoreStored = localStorage.getItem(LEARN_MORE_STORAGE_KEY)
    if (learnMoreStored === "true" && this.hasLearnMoreBodyTarget) {
      this.learnMoreBodyTarget.classList.add("hidden")
      if (this.hasLearnMoreHeaderTarget) {
        this.learnMoreHeaderTarget.classList.remove("open")
        this.learnMoreHeaderTarget.classList.remove("border-neutral-200")
      }
      if (this.hasLearnMoreCaretTarget) this.learnMoreCaretTarget.classList.remove("rotate-180")
    }
  }

  toggleBanner() {
    if (!this.hasBannerWrapperTarget) return
    const isCollapsed = this.bannerWrapperTarget.classList.toggle("collapsed")
    localStorage.setItem(STORAGE_KEY, String(isCollapsed))
    this.updateCollapseLabel(isCollapsed)
    this.updateCollapseIcon(isCollapsed)
  }

  updateCollapseLabel(isCollapsed) {
    if (this.hasCollapseLabelTarget) {
      this.collapseLabelTarget.textContent = isCollapsed ? "Expand" : "Minimise"
    }
  }

  updateCollapseIcon(isCollapsed) {
    if (this.hasCollapseIconTarget) {
      this.collapseIconTarget.classList.toggle("rotate-180", isCollapsed)
    }
  }

  toggleLearnMore() {
    if (this.hasLearnMoreBodyTarget) {
      this.learnMoreBodyTarget.classList.toggle("hidden")
    }
    if (this.hasLearnMoreHeaderTarget) {
      this.learnMoreHeaderTarget.classList.toggle("border-neutral-200")
      this.learnMoreHeaderTarget.classList.toggle("open")
    }
    if (this.hasLearnMoreCaretTarget) {
      this.learnMoreCaretTarget.classList.toggle("rotate-180")
    }
    const isCollapsed = this.hasLearnMoreBodyTarget && this.learnMoreBodyTarget.classList.contains("hidden")
    localStorage.setItem(LEARN_MORE_STORAGE_KEY, String(isCollapsed))
  }
}
